<div class="success-modal-wrapper">
	<div class="success-modal-header">
		<h2 class="success-modal-header__title">Thank you</h2>
		<button (click)="close()">
			<mat-icon>close</mat-icon>
		</button>
	</div>
	<div class="success-modal-body">
		<div class="success-modal-body__success-message">
			<p>Your case has been successfully submitted</p>
			<p>
				A confirmation will be sent to: <span class="user-email">{{ data.userEmail }}.</span>
			</p>
		</div>
		<div class="success-modal-body__signature">
			<div class="success-modal-body__signature__brand">
				<app-main-logo [imgHeight]="40"></app-main-logo>
			</div>
			<div class="success-modal-body__signature__text">
				<strong>The Zesty Support team</strong>
			</div>
		</div>
	</div>
	<div class="success-modal-actions-buttons">
		<button type="submit" mat-raised-button color="primary" (click)="close()">Close</button>
	</div>
</div>
